<template>
  <div>
    <factorings-controllers
      :factorings-selection="factoringsSelection"
      @filterFactoringsDueFrom="filterFactoringsDueFrom"
      @filterFactoringsDueTo="filterFactoringsDueTo"
      @filterFactoringsCreatedFrom="filterFactoringsCreatedFrom"
      @filterFactoringsCreatedTo="filterFactoringsCreatedTo"
      @filterFactorings="filterFactorings"
      @clearDate="clearDate"/>
    <v-card>
      <search-text-field
        :search-phrase="factoringSearch"
        :row-count="factoringsRowCount"
        @search="factoringSearchRefresh"
      />
      <factorings-datagrid
        :factoring-report-data="factoringReportData"
        :factorings-loading="factoringsLoading"
        :row-count="factoringsRowCount"
        :rows-per-page="factoringsRowsPerPage"
        @refreshWithSort="refreshFactoringsWithSort"
      />
      <div class="text-xs-center pt-2">
        <pagination
          :selected-page="factoringsSelectedPage"
          :rows-per-page="factoringsRowsPerPage"
          :row-count="factoringsRowCount"
          @changeDisplayedRowCount="factoringsChangeDisplayedRowCount"
          @clickedPage="changeFactopringsPage"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import FactoringsControllers from './FactoringsControllers';
import FactoringsDatagrid from './FactoringsDatagrid';
import Pagination from '../../controllers/Pagination.vue';
import SearchTextField from '../../controllers/SearchTextField';
    export default {
        name: "FactoringsReport",
        components: {FactoringsControllers, FactoringsDatagrid, Pagination, SearchTextField},
        data ()
        {
            return {
                factoringsSelection: 'all',
                factoringSearch: '',

                factoringsSelectedPage: 1,
                factoringsRowsPerPage: 5,
                factoringsRowCount: 0,
                factoringsSorting: {},
                factoringReportData: [],
                factoringsLoading: false,

                factoringsDueFromDate: null,
                factoringsDueToDate: null,
                factoringsCreatedToDate: null,
                factoringsCreatedFromDate: null,
            }
        },
        mounted ()
        {
          // this.refreshFactoringsReportData();
        },
        methods: {
            clearDate (target)
            {
                let self = this;

                switch (target) {
                    case 'dueFromDate':
                        self.factoringsDueFromDate = null;
                        break;
                    case 'dueToDate':
                        self.factoringsDueToDate = null;
                        break;
                    case 'createdFromDate':
                        self.factoringsCreatedFromDate = null;
                        break;
                    case 'createdToDate':
                        self.factoringsCreatedToDate = null;
                        break;
                }
                self.refreshFactoringsReportData();
            },
            factoringsChangeDisplayedRowCount (rowCount)
            {
                let self = this;

                self.factoringsSelectedPage = 1;
                self.factoringsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
                self.refreshFactoringsReportData();
            },
            changeFactopringsPage (page)
            {
                let self = this;

                self.factoringsSelectedPage = page;
                self.refreshFactoringsReportData();
            },

            //filter
            filterFactorings (selection)
            {
                this.factoringsSelection = selection;
                this.refreshFactoringsReportData ();
            },

            //dateFilters
            filterFactoringsDueFrom(date)
            {
                let self = this;

                self.factoringsDueFromDate = date;
                self.refreshFactoringsReportData ();
            },
            filterFactoringsDueTo(date)
            {
                let self = this;

                self.factoringsDueToDate = date;
                self.refreshFactoringsReportData ();
            },
            filterFactoringsCreatedFrom(date)
            {
                let self = this;

                self.factoringsCreatedFromDate = date;
                self.refreshFactoringsReportData ();
            },
            filterFactoringsCreatedTo(date)
            {
                let self = this;

                self.factoringsCreatedToDate = date;
                self.refreshFactoringsReportData ();
            },

            refreshFactoringsWithSort (pagination)
            {
                let self = this;

                self.factoringsSorting = {};
                self.factoringsSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
                self.refreshFactoringsReportData ();
            },
            factoringSearchRefresh (search)
            {
              let self = this;

              if (search !== '')
              {
                self.factoringsSelectedPage = 1
              }
              self.factoringSearch = search;
              self.refreshFactoringsReportData();
            },
            refreshFactoringsReportData ()
            {
                let self = this;

                self.factoringsLoading = true;
                let applicationFetch = self.$store.dispatch('factorings/getFactoringReport', {page: self.factoringsSelectedPage, rowsPerPage: self.factoringsRowsPerPage, dueFrom: self.factoringsDueFromDate, dueTo: self.factoringsDueToDate, createdFrom:self.factoringsCreatedFromDate, createdTo:self.factoringsCreatedToDate, selection: 'repaid', sort: self.factoringsSorting, search: self.factoringSearch });
                applicationFetch.then(response =>
                    {
                        self.processFactoringsReport(response);
                        self.factoringsLoading = false;
                    }, () =>
                    {
                        // error
                        self.factoringsLoading = false;
                    }
                );
            },
            processFactoringsReport (obj)
            {
                let self = this;

                let factoringReports = obj.Rows;
                self.factoringReportData = [];
                for (let factoringReport of factoringReports)
                {
                    let factoringReportClient = {
                        id: factoringReport.Id,
                        status: factoringReport.Status,
                        leftToPay: factoringReport.LeftToPay,
                        debtorName: factoringReport.DebtorName,
                        debtorRegistryId: factoringReport.DebtorRegistryId,
                        factoringDueDate: factoringReport.FactoringDueDate,
                        amount: factoringReport.Capital,
                        initialTransferAmount: factoringReport.InitialTransferAmount,
                        created: factoringReport.Created,
                        account: factoringReport.Account
                    };
                    self.factoringReportData.push(factoringReportClient);
                }
                self.factoringsRowCount = obj.TotalRowCount;
            },
        }

    }
</script>

<style scoped>

</style>
